export default __webpack_public_path__ + "static/media/PCM300.05c05afd.jpg";